import { TaskTemplate } from "./models";
import { TaskTemplateSchema } from "./schema";
import { CreateTaskTemplatePayload, UpdateTaskTemplatePayload } from "./models/payloads";

export function taskTemplatePrimaryTrigger(template: TaskTemplate) {
  return template?.startAtTrigger;
}

/**
 * Transform API response data to form data
 * No conversion needed for triggers - they use the same format now
 *
 * @param data - TaskTemplate from API response
 * @returns TaskTemplateSchema ready for form initialization
 */
export function toTaskTemplateFormData(data: TaskTemplate): TaskTemplateSchema {
  const {
    dueAtTrigger,
    startAtTrigger,
    reminders = [],
    paths = [],
    allowWeekends,
    taskAction,
    ...rest
  } = data;

  // Build result - no trigger conversion needed
  const result: TaskTemplateSchema = {
    ...rest,
    dueAtTrigger,
    startAtTrigger,
    paths,
    reminders,
    taskAction: taskAction ?? undefined,
    allowWeekends: allowWeekends ?? false,
  };

  return result;
}

/**
 * Transform form data (from Yup schema) to API create payload
 * Removes form-only fields and ensures correct structure for API
 */
export function toCreateTaskTemplatePayload(formData: TaskTemplateSchema): CreateTaskTemplatePayload {

  const { paths, ...rest } = formData;

  // Type assertion needed because form types differ from API types
  // (e.g., form triggers don't have id/timestamps, form assignee is partial)
  return rest as CreateTaskTemplatePayload;
}

/**
 * Transform form data (from Yup schema) to API update payload
 * Same as create but all fields optional
 */
export function toUpdateTaskTemplatePayload(formData: Partial<TaskTemplateSchema>): UpdateTaskTemplatePayload {

  const { paths, ...rest } = formData;

  return rest as UpdateTaskTemplatePayload;
}
